export const AUTH_ERROR = "AUTH_ERROR";

export const DOWNLOAD_COMPLETED = "DOWNLOAD_COMPLETED";
export const DOWNLOAD_FAILED = "DOWNLOAD_FAILED";

export type DOWNLOAD_STATUS = typeof AUTH_ERROR | typeof DOWNLOAD_COMPLETED | typeof DOWNLOAD_FAILED;

export const SYNC_COMPLETED = "SYNC_COMPLETED";
export const SYNC_FAILED = "SYNC_FAILED";

export type SYNC_STATUS = typeof AUTH_ERROR | typeof SYNC_COMPLETED | typeof SYNC_FAILED;

export const REQUEST_SITE_DOWNLOAD = "REQUEST_SITE_DOWNLOAD";
export const REQUEST_SITE_SYNC = "REQUEST_SITE_SYNC";
export const REQUEST_CACHE_EXPORT = "REQUEST_CACHE_EXPORT";
